module.exports = __webpack_public_path__ + "static/media/cia32.6c4c8c88.png";